import '../../styles/LoadingScreen.scss';

export default function LoadingScreen(props: { visible: boolean }) {
    return (
        <div id="loadingScreen" className={props.visible?"visible":""}>
            <div className="spinner"/>
        </div>
    );
}